import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { detailColleges, updateColleges } from '../actions/collegeActions'
import Country from '../components/Country'
import Header from '../components/Header'
import LeftComponent from '../components/LeftComponent'
import { COLLEGE_GET_RESET, COLLEGE_UPDATE_RESET } from '../constants/collegeConstants'
import { universityJson } from '../models/universityModel'

export default function UniversityEditScreen(props) {
    const { id } = useParams();
    const dispatch = useDispatch();

    const [clg, setClg] = useState(universityJson);

    const [executed, setExecuted] = useState(0);

    const collegeDetails = useSelector(state => state.collegeDetails)
    const { loading: loadingDetail, error: errorDetail, college } = collegeDetails

    const collegeUpdate = useSelector(state => state.collegeUpdate)
    const { loading: loadingUpdate, error: errorUpdate, success: successUpdate } = collegeUpdate

    const handleCollegeValues = (e) => {
        setClg({ ...clg, [e.target.name]: e.target.value });
    }

    const updateUniversity = (e) => {
        dispatch(updateColleges(id, clg))
        setExecuted(0)
    }

    useEffect(() => {
        if (successUpdate) {
            setTimeout(() => {
                dispatch({
                    type: COLLEGE_UPDATE_RESET
                })
            }, 10000);
            
        }

        if(executed == 0){
            dispatch({
                type: COLLEGE_GET_RESET
            })
            setExecuted(1)
        }

        if(college == undefined){
            dispatch(detailColleges(id))
        }else if(college.length == 0){
            dispatch(detailColleges(id))
        }else{
            setClg(college[0])
        }
        // if (id != undefined) {
        //     if (college == undefined || college.length == 0) {
        //         dispatch(detailColleges(id))
        //     }
        //     else {
        //         setClg(college[0])
        //     }
        // }
    }, [dispatch, id, college, successUpdate])

    return (
        <>
            <Header pageName="University" />
            <LeftComponent />
            <div className="content-body">
                <div className="container-fluid">
                    <div className="heading-title">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="home-title float-left">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="inner-body">
                        <div className="invoice-details">
                            <div className="container">
                                <div id="InvoiceAccordion" className="accordion-invoice">
                                    <div className="card mb-0">
                                        <div className="card-header collapsed" data-toggle="collapse" href="#collapseOne">
                                            <a className="card-title">
                                                University Details
                                            </a>
                                        </div>

                                        <div id="collapseOne" className="card-body collapse show" data-parent="#InvoiceAccordion" >
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">University Name* &nbsp; &nbsp;</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <input type="text" className="form-control form-control-sm" placeholder="University Name"
                                                                name="University_Name"
                                                                value={clg.University_Name}
                                                                onChange={e => handleCollegeValues(e)} />
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">University Address* &nbsp; &nbsp;</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <textarea className="form-control form-control-sm" placeholder="type here..."
                                                                name="University_Address"
                                                                value={clg.University_Address}
                                                                onChange={e => handleCollegeValues(e)}></textarea>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Country* &nbsp; &nbsp;</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <select
                                                                className="form-control form-control-sm"
                                                                name="Country_Id"
                                                                value={clg.Country_Id}
                                                                onChange={e => handleCollegeValues(e)} >
                                                                <option value="">--Select--</option>
                                                                <Country />
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">World Ranking</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm notification-send">
                                                            <input className="form-control form-control-sm" name="World_Ranking" value={clg.World_Ranking} onChange={e => handleCollegeValues(e)} placeholder="world ranking" />
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Country Ranking</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm notification-send">
                                                            <input className="form-control form-control-sm" name="Country_Ranking" value={clg.Country_Ranking} onChange={e => handleCollegeValues(e)} placeholder="country ranking" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card-header collapsed" data-toggle="collapse" data-parent="#InvoiceAccordion" href="#collapseTwo">
                                            <a className="card-title">
                                                Other Details
                                            </a>
                                        </div>
                                        <div id="collapseTwo" className="card-body collapse show" data-parent="#InvoiceAccordion" >
                                            <div className="row">
                                                <div className="col-md-6">

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Contact Person*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <input type="text" className="form-control form-control-sm" name="Contact_Person" value={clg.Contact_Person} onChange={e => handleCollegeValues(e)} placeholder="contact person" />

                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Contact Person Email*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <input type="text" className="form-control form-control-sm" name="Contact_Email" value={clg.Contact_Email} onChange={e => handleCollegeValues(e)} placeholder="contact person email" />

                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Contact Person Number*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <input type="text" className="form-control form-control-sm" name="Contact_Number" value={clg.Contact_Number} onChange={e => handleCollegeValues(e)} placeholder="contact person number" />

                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Partnership*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <select type="text" className="form-control form-control-sm" name="Partnership" value={clg.Partnership} onChange={e => handleCollegeValues(e)} >
                                                                <option value="">--Select--</option>
                                                                <option value="1">Yes</option>
                                                                <option value="0">No</option>
                                                            </select>

                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Affiliation*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <select type="text" className="form-control form-control-sm" name="Affiliation" value={clg.Affiliation} onChange={e => handleCollegeValues(e)} >
                                                                <option value="">--Select--</option>
                                                                <option value="1">On-Shore Student</option>
                                                                <option value="2">Off-Shore Student</option>
                                                                <option value="3">Both</option>

                                                            </select>

                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Affiliation Pathway*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <select type="text" className="form-control form-control-sm" name="Affiliation_Pathway" value={clg.Affiliation_Pathway} onChange={e => handleCollegeValues(e)} >
                                                                <option value="">--Select--</option>
                                                                <option value="1">Direct - Online</option>
                                                                <option value="2">Direct - Offline</option>
                                                                <option value="3">Other - Online</option>
                                                                <option value="4">Other - Offline</option>
                                                            </select>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className="card-header collapsed" data-toggle="collapse" data-parent="#InvoiceAccordion" href="#collapseThree">
                                            <a className="card-title">
                                                Commission Details
                                            </a>
                                        </div>
                                        <div id="collapseThree" className="card-body collapse  show" data-parent="#InvoiceAccordion" >
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Commission Percentage UG*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <input type="text" className="form-control form-control-sm" placeholder="commission percentage" name="Commision_Percentage_UG" value={clg.Commision_Percentage_UG} onChange={e => handleCollegeValues(e)} />

                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">%</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Commision_Percentage_PG*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <input type="text" className="form-control form-control-sm" placeholder="commission percentage pg" name="Commision_Percentage_PG" value={clg.Commision_Percentage_PG} onChange={e => handleCollegeValues(e)} />

                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">%</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Commision_Percentage_Other*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <input type="text" className="form-control form-control-sm" placeholder="commission percentage other" name="Commision_Percentage_Other" value={clg.Commision_Percentage_Other} onChange={e => handleCollegeValues(e)} />

                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">%</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Lumpsum_Commision</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">$</span>
                                                            </div>
                                                            <input type="text" className="form-control form-control-sm" placeholder="Lumpson Commission" name="Lumpsum_Commision" value={clg.Lumpsum_Commision} onChange={e => handleCollegeValues(e)} />
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Commision Including GST</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <select type="text" className="form-control form-control-sm" name="Commision_Including_GST" value={clg.Commision_Including_GST} onChange={(e) => handleCollegeValues(e)}>
                                                                <option value="">--Select--</option>
                                                                <option value="1">Yes</option>
                                                                <option value="0">No</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Commission Duration</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <input type="text" className="form-control form-control-sm" name="Commission_Duration" value={clg.Commission_Duration} onChange={e => handleCollegeValues(e)} placeholder="commission duration"
                                                            />

                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-12 text-center">
                                                    <hr />
                                                    {
                                                        loadingDetail ? (
                                                            <>Loading...</>
                                                        ) : (
                                                            <>
                                                                {
                                                                    (id == '' || id == undefined) ? (
                                                                        <>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            {
                                                                                loadingUpdate ? (
                                                                                    <>
                                                                                        Loading...
                                                                                    </>
                                                                                ) : (
                                                                                    <div className="Create-btn">
                                                                                        <a
                                                                                            href="javascript:void(0)"
                                                                                            className="btn create-contact"
                                                                                            onClick={e => updateUniversity(e)}>Update</a>
                                                                                    </div>
                                                                                )
                                                                            }
                                                                        </>
                                                                    )
                                                                }
                                                            </>
                                                        )
                                                    }
                                                    {/* <div className="Create-btn">
                                                        <a className="btn create-contact"
                                                            onClick={e => SaveUniversity(e)}>Save</a>
                                                    </div> */}

                                                    <span className='text-success'>{successUpdate}</span>
                                                    <span className='text-danger'>{errorUpdate}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

